import { QuestionPassStateId } from '../../../learnware/LearnwareEnums';
import { QuestionPassState } from '../QuestionPassState';
export class QuestionPassState_Wrong extends QuestionPassState {
    id = QuestionPassStateId.Wrong;
    name = 'Falsch beantwortet';
    color = 'danger';
    orderInProgressbar = 6;
}
